<template>
    <div id="data-list-list-view" class="xxdata-list-container padTop32">
        <div class="filterWrap">
          <gc-cmp-vs-input v-model="filterText" class="filterInput"
                           @input="getTableData(1)"
                           placeholder="请输入供应商名称/编码"  />
           <vs-button v-if="filtering('supplier:add')" @click="addNewSupplier(true)">新增</vs-button>
        </div>

        <gc-cmp-vs-table :data="tableData" :pager="pager">
            <template slot="thead">
              <vs-th v-for="(column, index) in columns" :key="index">
                {{column.name}}
              </vs-th>
            </template>
            <template slot-scope="{data}">
                <tbody>
                  <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>{{indextr + 1 }}</vs-td>
                    <vs-td>{{tr.code}}</vs-td>
                    <vs-td>{{tr.name}}</vs-td>
                     <vs-td class="whitespace-no-wrap">
                        <feather-icon v-if="filtering('supplier:update')" icon="EditIcon" svgClasses="w-5 h-5 stroke-current" class="text-primary"
                                      @click.stop="addNewSupplier(false, tr)" />
                        <feather-icon v-if="filtering('supplier:delete')" icon="TrashIcon" svgClasses="w-5 h-5 stroke-current" class="ml-2 text-primary"
                                      @click.stop="deleteSupplier(tr)" />
                    </vs-td>
                  </vs-tr>
                </tbody>
            </template>
          </gc-cmp-vs-table>
          <!-- 分页 -->
            <!-- <gc-vs-pagination
            class="mt-5"
            :total="pager.totalCount"
            v-model="pager.page"
            :max-items="pager.size"
          ></gc-vs-pagination> -->
        <gc-vs-pagination
          :pager="pager"
          totalName="totalCount"
          @handleSizeChange="handleSizeChange"
          @handleCurrentChange="handleCurrentChange"
          ></gc-vs-pagination>
    </div>
</template>

<script>
    import GcCmpVsInput from "@/group-cloud/components/vsInput";
    import GcCmpVsTable from "@/group-cloud/components/vsTable";
    import {WmsSupplierApi} from "@/modules/server-api/wms-manage/supplier";
    export default {
      data() {
          return {
            filterText:"",//模糊搜索
            editPageUrl: '/modules/wms/manage/supplier/edit',
            columns:[{
                name:"序号"
              },{
                name:"供应商编码"
              },{
                name:"供应商名称"
              },{
                name:"操作"
              }],
            tableData:[],
            pager:{
              page: 1,
              size: 20,
              totalCount: 0
            }
          }
      },
      components: {
          GcCmpVsInput, GcCmpVsTable
      },
      methods: {
        //获取分类数据
        async getTableData(page){
          this.$vs.loading();
            this.tableData = [];
            let pageSize = this.pager.size
            let pageNo = page || this.pager.page
            let resp = await WmsSupplierApi.getSupplierList({
              "pageNo": pageNo,
              "pageSize": pageSize,
              "data":{suggest: this.filterText}
            });
            console.log('resp',resp)
            // let Count = this.pager.totalCount ;
            let resCount = resp.result.totalCount;
            //this.pager.totalCount = Math.ceil(resCount / pageSize)
            this.pager.totalCount = resCount;
            this.tableData = resp.result.list;
            this.$vs.loading.close();
        },
        //新增供应商
        addNewSupplier(isNew, row){
          let title = '';
          if(isNew){
            title = "新增";
            sessionStorage.setItem("supplierId", "");
          }else{
            title = "编辑";
            sessionStorage.setItem("supplierId", row.id);
          }
          sessionStorage.setItem("title", title);
          this.$router.push({path: this.editPageUrl}).catch(() => {})
        },
        //删除供应商
        deleteSupplier(row){
          this.$vs.dialog({
              type: 'confirm',
              title:`操作提示`,
              text: `您确认删除该供应商吗？`,
              acceptText: '确认',
              cancelText: '取消',
              accept: () => {this.doDeleteGoods(row)}
          })
        },
        async doDeleteGoods(row){
          let res = await WmsSupplierApi.deleteSupplier({"id":row.id});
          if(res.succ == 1){
            this.$notifySuccess('删除成功');
            this.getTableData();
          }else{
            this.$notifyError(res.error);
          }
        },
        //更改每页条数
        handleSizeChange(val){
          this.pager.size = val;
          this.getTableData();
        },
        handleCurrentChange(val){
          this.pager.page = val;
          this.getTableData();
        }
      },
      watch:{
      //  pager: {
      //     handler(val) {
      //       this.getTableData()
      //     },
      //     deep: true
      //   }
      },
      created() {
        this.getTableData();
      }
  }
</script>

<style lang="scss" scoped>
 @import '@/modules/commodity-sys/commodity.scss';
  #data-list-list-view{
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    .categoryHead{
      background-color: #F3F2F7;
      height: 38px;
      line-height: 38px;
      .vs-col{
        color: #5E5873;
      }
    }
    .optCol{
        display: flex;
        justify-content: flex-end;
        padding-right: 18px;
    }
  }
</style>
